import { Faq } from "@/types/dto/category.dto";
import { cn } from "@/lib/utils";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "lucide-react";

const FAQTab = ({ faqs }: { faqs?: Faq[] }) => {
	return (
		<div className="rounded-lg bg-white p-6">
			{faqs && faqs.length > 0 ? (
				faqs?.map((faq, i) => (
					<Disclosure key={i}>
						{({ open }) => (
							<div className="mb-2 rounded-lg border py-2 last:mb-0">
								<Disclosure.Button className="flex w-full justify-between rounded-lg px-4 py-2 text-left">
									<h5 className="font-medium">{faq.question}</h5>
									<span>
										<ChevronUpIcon
											className={cn(
												!open ? "rotate-180 transform" : "text-brand-primary",
												"h-5 w-5"
											)}
										/>
									</span>
								</Disclosure.Button>
								<Disclosure.Panel className="whitespace-pre-wrap px-4 py-2 text-gray-500">
									{faq.answer}
								</Disclosure.Panel>
							</div>
						)}
					</Disclosure>
				))
			) : (
				<span>No FAQs found</span>
			)}
		</div>
	);
};

export default FAQTab;
